// extracted by mini-css-extract-plugin
export default {"tabs":"WhyIsAirQualityImportant_tabs__koK49","tabContainer":"WhyIsAirQualityImportant_tabContainer__zuhle"};